(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('psk-visible'); observer.unobserve(entry.target); } }), { threshold: 0.08 });
    document.querySelectorAll('[data-psk-reveal]').forEach(node => observer.observe(node));
  }
  document.querySelectorAll('[data-psk-nav]').forEach(nav => {
    nav.addEventListener('toggle', () => { if (nav.open) document.querySelectorAll('[data-psk-nav]').forEach(other => { if (other !== nav) other.open = false; }); });
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { nav.open = false; }));
  });
  document.addEventListener('click', event => document.querySelectorAll('[data-psk-nav][open]').forEach(nav => { if (!nav.contains(event.target)) nav.open = false; }));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('[data-psk-nav][open]').forEach(nav => { nav.open = false; nav.querySelector('summary')?.focus(); }); });
  document.querySelectorAll('[data-psk-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  const showPanel = (gallery, id) => {
    if (!gallery) return;
    gallery.querySelectorAll('[data-pz-gallery-panel]').forEach(panel => { panel.hidden = panel.id !== id; });
    gallery.querySelectorAll('[data-pz-panel]').forEach(button => {
      const active = button.dataset.pzPanel === id;
      button.setAttribute('aria-pressed', String(active));
      const track = button.parentElement;
      if (active && track.scrollWidth > track.clientWidth) {
        const left = button.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - (track.clientWidth - button.clientWidth) / 2;
        track.scrollTo({ left: Math.max(0, left), behavior: reduced ? 'instant' : 'smooth' });
      }
    });
  };
  document.querySelectorAll('[data-pz-gallery]').forEach(gallery => {
    const buttons = Array.from(gallery.querySelectorAll('[data-pz-panel]'));
    buttons.forEach(button => button.addEventListener('click', () => showPanel(gallery, button.dataset.pzPanel)));
    const move = direction => { const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true'); const next = buttons[(current + direction + buttons.length) % buttons.length]; if (next) showPanel(gallery, next.dataset.pzPanel); };
    gallery.querySelector('[data-pz-gallery-prev]')?.addEventListener('click', () => move(-1));
    gallery.querySelector('[data-pz-gallery-next]')?.addEventListener('click', () => move(1));
  });
  document.querySelectorAll('[data-pz-reviews]').forEach(root => {
    const slides = Array.from(root.querySelectorAll('[data-pz-review-slide]'));
    const move = direction => { const index = slides.findIndex(slide => !slide.hidden); const next = (index + direction + slides.length) % slides.length; slides.forEach((slide, i) => { slide.hidden = i !== next; }); };
    root.querySelector('[data-pz-review-prev]')?.addEventListener('click', () => move(-1));
    root.querySelector('[data-pz-review-next]')?.addEventListener('click', () => move(1));
  });
  document.querySelectorAll('[data-psk-product]').forEach(root => {
    const form = root.querySelector('form');
    const button = root.querySelector('[data-psk-add]');
    const label = root.querySelector('[data-psk-add-label]');
    const checkoutButton = root.querySelector('[data-psk-checkout]');
    const checkoutLabel = root.querySelector('[data-psk-checkout-label]');
    if (checkoutButton) checkoutButton.hidden = false;
    const total = root.querySelector('[data-pz-total]');
    const error = root.querySelector('[data-pz-error]');
    const formatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: root.dataset.currency || 'EUR' });
    const select = root.querySelector('[data-psk-variant]');
    const modelPicker = root.querySelector('[data-pz-model-picker]');
    const modelCards = Array.from(root.querySelectorAll('[data-pz-model]'));
    const syncModel = () => {
      if (!select) return;
      const current = modelCards.find(card => card.dataset.pzModel === select.value);
      modelCards.forEach(card => card.setAttribute('aria-pressed', String(card === current)));
      const selected = root.querySelector('[data-pz-model-selected]');
      if (selected && current) selected.textContent = current.dataset.modelLabel;
    };
    const genericOffers = Array.from(root.querySelectorAll('[data-generic-offer]'));
    const update = choice => {
      if (!choice) return;
      const available = choice.dataset.available === 'true';
      const enteredQuantity = Number(root.querySelector('[data-pz-quantity]')?.value || 1);
      const maxQuantity = choice.dataset.maxQuantity === undefined ? Infinity : Number(choice.dataset.maxQuantity);
      const quantityValid = Number.isInteger(enteredQuantity) && enteredQuantity >= 1 && enteredQuantity <= maxQuantity;
      button.disabled = !available || !quantityValid;
      if (checkoutButton) checkoutButton.disabled = !available || !quantityValid;
      label.textContent = available ? button.dataset.addLabel : button.dataset.unavailableLabel;
      const quantity = root.querySelector('[data-psk-pack-quantity]');
      if (quantity) quantity.value = choice.dataset.quantity;
      const genericQuantity = root.querySelector('[data-pz-quantity]');
      if (total) total.textContent = genericQuantity ? formatter.format(Number(choice.dataset.cents) * Number(genericQuantity.value || 1) / 100) : choice.dataset.price;
      const reference = root.querySelector('[data-pz-reference]');
      if (reference) { reference.hidden = Number(choice.dataset.referenceCents || 0) <= Number(choice.dataset.cents); reference.querySelector('[data-pz-reference-value]').textContent = genericQuantity ? formatter.format(Number(choice.dataset.referenceCents || choice.dataset.cents) * enteredQuantity / 100) : choice.dataset.reference; }
      const content = root.querySelector('[data-pz-content]');
      if (content) { const count = Number(choice.dataset.contentCount || 1) * enteredQuantity; content.textContent = `${count} ${count === 1 ? choice.dataset.contentOne : choice.dataset.contentMany}`; }
      const stock = root.querySelector('[data-pz-stock-label]');
      if (stock) { stock.textContent = available ? choice.dataset.stockLabel || stock.dataset.availableLabel : button.dataset.unavailableLabel; stock.style.color = available ? '#1c9047' : '#b53535'; }
      root.closest('.pz-product')?.querySelectorAll('[data-pz-displayed-total]').forEach(node => { node.textContent = total?.textContent || choice.dataset.price; });
      if (error) error.hidden = true;
    };
    const configureGenericOffers = variant => {
      if (!variant || !genericOffers.length) return;
      const cents = Number(variant.dataset.cents);
      const maxQuantity = variant.dataset.maxQuantity === undefined ? Infinity : Number(variant.dataset.maxQuantity);
      genericOffers.forEach(offer => {
        const units = Number(offer.dataset.units);
        const available = variant.dataset.available === 'true' && units <= maxQuantity;
        const baseTotal = cents * units;
        const discountedTotal = (cents - Math.floor(cents * Number(offer.dataset.discountPercent) / 100)) * units;
        const contentCount = Number(variant.dataset.contentCount || 1) * units;
        offer.dataset.items = JSON.stringify([{ id: Number(variant.value), quantity: units }]);
        offer.dataset.price = formatter.format(discountedTotal / 100);
        offer.dataset.cents = String(discountedTotal);
        offer.dataset.reference = formatter.format(baseTotal / 100);
        offer.dataset.referenceCents = String(baseTotal);
        offer.dataset.available = String(available);
        offer.dataset.stockLabel = variant.dataset.inventoryQuantity !== undefined && units > Number(variant.dataset.inventoryQuantity) ? root.dataset.backorderLabel : variant.dataset.stockLabel;
        offer.dataset.contentCount = String(contentCount);
        offer.dataset.contentOne = variant.dataset.contentOne;
        offer.dataset.contentMany = variant.dataset.contentMany;
        offer.disabled = !available;
        const card = offer.closest('.pz-offer');
        card.querySelector('[data-pz-offer-unit-price]').textContent = formatter.format(discountedTotal / units / 100);
        card.querySelector('[data-pz-offer-total]').textContent = root.dataset.totalLabel + ' ' + formatter.format(discountedTotal / 100);
        card.querySelector('[data-pz-offer-saving]').textContent = Number(offer.dataset.discountPercent) > 0 ? '−' + offer.dataset.discountPercent + ' % ' + root.dataset.savingLabel : '';
        card.querySelector('[data-pz-offer-content]').textContent = contentCount + ' ' + (contentCount === 1 ? variant.dataset.contentOne : variant.dataset.contentMany);
        card.querySelector('[data-pz-offer-unavailable]').hidden = available;
      });
      let selected = root.querySelector('[data-psk-offer]:checked');
      if (selected?.disabled) {
        const available = genericOffers.find(offer => !offer.disabled);
        if (available) { available.checked = true; selected = available; }
      }
      update(selected);
    };
    root.querySelectorAll('[data-psk-offer]').forEach(radio => radio.addEventListener('change', () => update(radio)));
    let selectedOffer = root.querySelector('[data-psk-offer]:checked');
    if (selectedOffer?.disabled) {
      const availableOffer = root.querySelector('[data-psk-offer]:not(:disabled)');
      if (availableOffer) { availableOffer.checked = true; selectedOffer = availableOffer; }
    }
    if (selectedOffer) update(selectedOffer);
    select?.addEventListener('change', () => {
      const variant = select.selectedOptions[0];
      syncModel();
      const quantity = root.querySelector('[data-pz-quantity]');
      if (quantity) { if (variant.dataset.maxQuantity === undefined) quantity.removeAttribute('max'); else quantity.max = String(Math.max(1, Number(variant.dataset.maxQuantity))); quantity.value = '1'; }
      if (genericOffers.length) configureGenericOffers(variant); else update(variant);
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.value); history.replaceState({}, '', url);
      const gallery = root.closest('.pz-product')?.querySelector('[data-pz-gallery]');
      const panel = gallery?.querySelector(`[data-pz-variant-photo="${variant.value}"]`);
      if (panel) showPanel(gallery, panel.id);
      else if (gallery?.querySelector(`#PeskImage-${variant.dataset.image}`)) showPanel(gallery, `PeskImage-${variant.dataset.image}`);
    });
    const quantityInput = root.querySelector('[data-pz-quantity]');
    quantityInput?.addEventListener('input', () => update(select?.selectedOptions[0]));
    quantityInput?.addEventListener('change', () => update(select?.selectedOptions[0]));
    if (select) {
      if (genericOffers.length) configureGenericOffers(select.selectedOptions[0]); else update(select.selectedOptions[0]);
      if (new URL(window.location.href).searchParams.get('variant') === select.value) {
        const gallery = root.closest('.pz-product')?.querySelector('[data-pz-gallery]');
        const panel = gallery?.querySelector(`[data-pz-variant-photo="${select.value}"]`);
        if (panel) showPanel(gallery, panel.id);
      }
    }
    if (select && modelPicker && modelCards.length) {
      modelCards.forEach(card => card.addEventListener('click', () => {
        select.value = card.dataset.pzModel;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      modelCards.forEach(card => {
        const option = Array.from(select.options).find(option => option.value === card.dataset.pzModel);
        if (option) card.querySelector('[data-pz-model-price]').textContent = formatter.format(Number(option.dataset.cents) / 100);
      });
      syncModel();
      root.querySelector('[data-pz-model-fallback]').hidden = true;
      modelPicker.hidden = false;
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled || form.dataset.submitting === 'true') return;
      const offer = root.querySelector('[data-psk-offer]:checked');
      const variant = select?.selectedOptions[0];
      if (offer && offer.dataset.available !== 'true') return;
      if (!offer && (!variant || variant.dataset.available !== 'true')) return;
      const quantity = Number(quantityInput?.value || 1);
      const maxQuantity = variant?.dataset.maxQuantity === undefined ? Infinity : Number(variant.dataset.maxQuantity);
      if (!offer && quantity > maxQuantity) return;
      if (!offer && (!Number.isInteger(quantity) || quantity < 1)) return;
      const items = offer ? JSON.parse(offer.dataset.items) : [{ id: Number(variant.value), quantity }];
      const goToCheckout = Boolean(checkoutButton && event.submitter === checkoutButton);
      form.dataset.submitting = 'true'; button.disabled = true; label.textContent = root.dataset.addingLabel; error.hidden = true;
      if (checkoutButton) { checkoutButton.disabled = true; if (goToCheckout) checkoutLabel.textContent = root.dataset.addingLabel; }
      const restoreButtons = () => {
        const choice = root.querySelector('[data-psk-offer]:checked') || select?.selectedOptions[0];
        update(choice);
        if (checkoutLabel) checkoutLabel.textContent = checkoutButton.dataset.checkoutLabel;
        form.dataset.submitting = 'false';
      };
      try {
        const response = await fetch(`${root.dataset.rootUrl}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || root.dataset.errorLabel);
        if (goToCheckout) window.location.assign(`${root.dataset.rootUrl}checkout`);
        else if (window.PeskCart) { await window.PeskCart.open(); restoreButtons(); }
        else window.location.assign(root.dataset.cartUrl);
      } catch (failure) { restoreButtons(); error.textContent = failure.message || root.dataset.errorLabel; error.hidden = false; error.setAttribute('tabindex', '-1'); error.scrollIntoView({ block: 'center', behavior: reduced ? 'instant' : 'smooth' }); error.focus({ preventScroll: true }); }
    });
  });
  document.querySelectorAll('[data-pz-sticky-buy]').forEach(bar => {
    const form = document.getElementById(bar.dataset.formId);
    const root = form?.closest('[data-psk-product]');
    const mainButton = root?.querySelector('[data-psk-add]');
    const mainLabel = root?.querySelector('[data-psk-add-label]');
    const total = root?.querySelector('[data-pz-total]');
    const stickyButton = bar.querySelector('[data-pz-sticky-submit]');
    const stickyTotal = bar.querySelector('[data-pz-sticky-total]');
    if (!form || !mainButton || !stickyButton || !total || !('IntersectionObserver' in window)) return;
    const sync = () => {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainLabel?.textContent || mainButton.textContent;
      stickyTotal.textContent = total.textContent;
    };
    sync();
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    new IntersectionObserver(entries => {
      const entry = entries[0];
      const visible = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      bar.hidden = !visible;
      document.body.classList.toggle('pz-has-sticky', visible);
    }).observe(mainButton);
    stickyButton.addEventListener('click', () => {
      if (!stickyButton.disabled) form.requestSubmit(mainButton);
    });
  });
  if (window.Shopify?.designMode || window.Shopify?.theme?.role === 'unpublished') {
    document.querySelectorAll('[data-pz-payment-preview]').forEach(preview => { preview.hidden = false; });
  }
  document.querySelectorAll('[data-pesk-print-guide]').forEach(button => button.addEventListener('click', () => window.print()));
  const announcement = document.querySelector('[data-psk-announcement]');
  const dismiss = document.querySelector('[data-psk-dismiss]');
  try { if (sessionStorage.getItem('pesk-announcement-dismissed') === '1') announcement?.remove(); } catch {}
  dismiss?.addEventListener('click', () => { announcement?.remove(); try { sessionStorage.setItem('pesk-announcement-dismissed', '1'); } catch {} });
})();
